import { Link } from "react-router-dom";
import { useGame } from "../contexts/GameContext";

export const Complete = () => {
    const { points } = useGame();

    return (
        <div className="complete">
            <header>
                <h1>Parabéns concluiste o jogo.</h1>
                <h2>A tua pontuação foi {points.current} em {points.max}</h2>
            </header>

            <nav>
                <Link to="/" className="btn">Recomeçar</Link>
            </nav>
        </div>
    )
};